import Vue from 'vue'
import _ from 'lodash'
import { SOCIAL_MEDIA_WRAPPER_OPTIONS } from '@/const'

const intialFormData = () => {
  return {
    id: null,
    fanzine_status: null,
    fanzine_type: null,
    fanzine_visibility: false,
    image: null,
    image_background: null,
    image_logo: null,
    image_map: null,
    image_nav: null,
    image_url: null,
    image_background_url: null,
    image_logo_url: null,
    image_map_url: null,
    image_nav_url: null,
    name: null,
    doc: {
      start: '',
      end: '',
      name: '',
      mainEventId: '',
      apiTimeout: 0,
      places: [],
      flatPages: [],
      newsHide: false,
      newsMainBackground: false,
      delegatesHide: false,
      delegatesMainBackground: false,
      artistsHide: false,
      artistsMainBackground: false,
      programHide: false,
      programMainBackground: false,
      notificationsHide: false,
      notificationsMainBackground: false,
      mapHide: false,
      mapMainBackground: false,
      ticketsHide: false,
      ticketsMainBackground: false,
      votingHide: false,
      votingMainBackground: false,
      myLineUpHide: false,
      myLineUpMainBackground: false,
      hideScenes: false,
      dayProgramGroups: true,
      sideMenu: {
        separators: {
          show: true,
          color: '#fff',
          size: 2,
        },
        dots: {
          show: false,
        }
      },
      news: {
        borderRadius: 8,
      },
      voting: {
        info: {
          text: {
            pl: '',
            en: ''
          }
        },
        eventCard: {
          borderRadius: 0,
          button: {
            borderRadius: 0,
            voted: {
              backgroundColor: '#ffffff',
              textColor: '#000000',
            },
            unvoted: {
              backgroundColor: '#000000',
              textColor: '#ffffff',
            }
          }
        },
      },
      program: {
        menu: {
          borderRadius: 0,
          lineColor: '#ffffff',
          active: {
            backgroundColor: '#000000',
            textColor: '#ffffff',
          },
          inactive: {
            backgroundColor: '#ffffff',
            textColor: '#000000',
          },
        },
        filterButton: {
          borderRadius: 0,
          marginRight: 10,
          active: {
            backgroundColor: '#000000',
            textColor: '#ffffff',
          },
          inactive: {
            backgroundColor: '#ffffff',
            textColor: '#000000',
          },
        },
      },
      sideMenuLinks: {
        size: 30,
        space: 20,
        marginTop: 20,
        marginBottom: 20,
        facebook: { link: '', visible: false, openWith: SOCIAL_MEDIA_WRAPPER_OPTIONS[0].value },
        spotify: { link: '', visible: false, openWith: SOCIAL_MEDIA_WRAPPER_OPTIONS[0].value },
        instagram: { link: '', visible: false, openWith: SOCIAL_MEDIA_WRAPPER_OPTIONS[0].value },
      },
      banner: {
        wv: {
          active: false,
          header: '',
          subheader: '',
          url: '',
          style: {
            color: '',
            bgc: '',
          },
        },
      },
      button: {
        steps: {
          visible: false,
          style: {
            color: '',
            bgc: '',
            colorActive: '',
            bgcActive: '',
          },
        },
        buy_ticket: {
          visible: false,
          style: {
            color: '',
            bgc: '',
            colorActive: '',
            bgcActive: '',
          },
        },
      },
      style: {
        color: '',
        colorActive: '',
        colorActiveText: '',
        navcolor: '',
        background: '',
        titlecolor: '',
        headercolor: '',
      },
      openDates: {},
      openTitle: {},
      dates: [],
      dateNames: [],
      events: [],
      scenesData: {
        scenes: [],
      },
      daysData: {
        days: [],
      },
      map: {
        startingPoint: { lat: 0, lon: 0 },
        markersCategories: [],
        markers: [],
      },
    },  
  }
}


export const fanzones = {
  state: {
    form: intialFormData(),
    fanzones: [],
    places: [],
    fanzonesByTypeId: {},
    loading: false,
  },
  mutations: {
    moveDownScene(state, payload) {
      const { idx } = payload;
      const { form } = state;
      const { scenesData: { scenes } } = form.doc;
      
      if (idx < scenes.length - 1) {
        [scenes[idx], scenes[idx + 1]] = [scenes[idx + 1], scenes[idx]];
        Vue.set(form.doc.scenesData, 'scenes', [...scenes]);
      }
    },
    moveUpScene(state, payload) {
      const { idx } = payload;
      const { form } = state;
      const { scenesData: { scenes } } = form.doc;
      
      if (idx > 0) {
        [scenes[idx - 1], scenes[idx]] = [scenes[idx], scenes[idx - 1]];
        Vue.set(form.doc.scenesData, 'scenes', [...scenes]);
      }
    },
    addFaqElementToList(state, payload) {
      const { flatPageId, itemId } = payload
      const { form } = state

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const item = flatPage.items.find((i) => i.id === itemId)

      if (!item.value['items']) {
        Vue.set(item.value, 'items', [])
      }

      const arrIds = item.value.items.map((e) => e.id)
      const maxId = Math.max(0, ...arrIds)

      item.value.items.push({
        id: maxId + 1,
        q: { pl: '', en: '' },
        a: { pl: '', en: '' },
      })
    },    
    removeItemFromArray(state, payload) {
      const { arrayObj, item, keyName } = payload

      console.log("removeItemFromArray", arrayObj, item)
      Vue.set(arrayObj, keyName, [...arrayObj[keyName].filter((it) => it !== item)])
    },
    addEventToScene(state, payload) {
      const { form } = state
      const { scene, day } = payload

      const arrIds = [0];
      if (!scene['events']) Vue.set(scene, 'events', []);

        
      form.doc.scenesData.scenes.map((scene) => {
        scene.events && scene.events.map((e) => {
          arrIds.push(e.id)
        })
      })

      const maxId = Math.max(0, ...arrIds)

      const event = {
        id: maxId + 1,
        dayId: day.id,
        artistId: null,
        name: { pl: null, en: null },
        dateFrom: null,
        dateTo: null,
        hideInArtists: false,
        hideInProgram: false,
        placeId: null,
        isDelegate: false,
      }

      Vue.set(scene, 'events', [...scene.events, event])
    },
    addDay(state, payload) {
      const { form } = state
      const { day: { name, date } } = payload
      if (!form['doc']['daysData']) Vue.set(form.doc, 'daysData', {})
      if (!form['doc']['daysData']['days']) Vue.set(form.doc.daysData, 'days', [])

      const arrIds = form['doc']['daysData']['days'].map((e) => e.id)
      const maxId = Math.max(0, ...arrIds)
      const day = { id: maxId + 1, name: { pl: name.pl, en: name.en }, date }

      Vue.set(form.doc.daysData, 'days', [...form.doc.daysData.days, day])
    },
    addSceneDate(state, payload) {
      //const { form } = state
      //const { scene, day } = payload

      //const s = form.doc.scenesData.scenes.find((s) => s.id === scene.id)

      //Vue.set(s, 'days', [...s.days, day])
    },
    addScene(state, payload) {
      const { form } = state
      const { name } = payload

      if (!form['doc']['scenesData']) Vue.set(form.doc, 'scenesData', {})
      if (!form['doc']['scenesData']['scenes']) Vue.set(form.doc.scenesData, 'scenes', [])

      const arrIds = form['doc']['scenesData']['scenes'].map((e) => e.id)
      const maxId = Math.max(0, ...arrIds)
      const scene = { id: maxId + 1, name: { pl: name.pl, en: name.en }, days: [], events: [] }

      Vue.set(form.doc.scenesData, 'scenes', [...form.doc.scenesData.scenes, scene])
    },    
    removeDate(state, payload) {
      const { dateId } = payload
      const { form, form: { doc: { dates, dateNames, events } } } = state

      const _dates =   
      dates.splice(dateId, 1)
      dateNames.splice(dateId, 1)
      if (events && events.length > 0) {
        let _events = []
        
        dates.map((date) => {
          events.filter((ev) => ev.date == date).map((ev) => _events.push(ev))
        })
        Vue.set(form.doc, 'events', _events)
      }
    },
    addDate(state) {
      const { form, form: { doc: { dates, dateNames } } } = state
      Vue.set(form.doc, 'dates', [...dates, ''])
      Vue.set(form.doc, 'dateNames', [...dateNames, ''])
    },
    itemImageLinkChanged(state, payload) {
      const { form } = state
      const { flatPageId, itemId, value } = payload

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const { items } = flatPage
      const item = items.find((i) => i.id === itemId)

      Vue.set(item, 'link', value)
    },
    imageListValueChanged(state, payload) {
      const { form } = state
      const { flatPageId, itemId, key, value } = payload

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const { items } = flatPage
      const item = items.find((i) => i.id === itemId)

      Vue.set(item, key, value)
    },
    imageListImagePropChanged(state, payload) {
      const { form } = state
      const { flatPageId, itemId, imageId, key, value } = payload

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const { items } = flatPage
      const item = items.find((i) => i.id === itemId)
      const image = item.value.images.find((i) => i.id === imageId)

      Vue.set(image, key, value)
    },
    moveImageLeftInImageList(state, payload) {
      const { form } = state
      const { flatPageId, itemId, imageId } = payload

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const { items } = flatPage
      const item = items.find((i) => i.id === itemId)
      const imageIdx = item.value.images.findIndex((i) => i.id === imageId)
      const { value: { images } } = item
      
      if (imageIdx > 0) {
        [images[imageIdx - 1], images[imageIdx]] = [images[imageIdx], images[imageIdx - 1]]
        Vue.set(item.value, 'images', [...images])
      }
    },
    moveImageRightInImageList(state, payload) {
      const { form } = state
      const { flatPageId, itemId, imageId } = payload

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const { items } = flatPage
      const item = items.find((i) => i.id === itemId)
      const imageIdx = item.value.images.findIndex((i) => i.id === imageId)
      const { value: { images } } = item
      
      if (imageIdx < images.length - 1) {
        [images[imageIdx], images[imageIdx + 1]] = [images[imageIdx + 1], images[imageIdx]]
        Vue.set(item.value, 'images', [...images])
      }
    },
    changeImageInList(state, payload) {
      const { form } = state
      const { flatPageId, itemId, imageId, value } = payload

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const item = flatPage.items.find((i) => i.id === itemId)
      const image = item.value.images.find((i) => i.id === imageId)

      Vue.set(image, 'base64', value)
    },
    removeImageFromList(state, payload) {
      const { flatPageId, itemId, imageId } = payload
      const { form } = state

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const item = flatPage.items.find((i) => i.id === itemId)
      const imageIdx = item.value.images.findIndex((i) => i.id === imageId)

      item.value.images.splice(imageIdx, 1)

      Vue.set(item.value, 'images', item.value.images)
    },
    addImageToList(state, payload) {
      const { flatPageId, itemId } = payload
      const { form } = state

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const item = flatPage.items.find((i) => i.id === itemId)

      if (!item.value['images']) {
        Vue.set(item.value, 'images', [])
      }

      const arrIds = item.value.images.map((e) => e.id)
      const maxId = Math.max(0, ...arrIds)

      item.value.images.push({
        id: maxId + 1,
        base64: null,
        url: null,
        link: null,
      })
    },
    fileUploaded(state, payload) {
      const { key, value } = payload
      const { form } = state

      if (!form[key]) {
        Vue.set(form, key, null)
      }

      Vue.set(form, key, value)
    },
    setData(state, payload) {
      const { key, value } = payload
      const { form } = state

      if (!form[key]) {
        Vue.set(form, key, null)
      }

      Vue.set(form, key, value)
    },
    itemBannerStyleChanged(state, payload) {
      const { flatPageId, itemId, field, key, value } = payload
      const { form } = state

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const item = flatPage.items.find((i) => i.id === itemId)

      if (!item['style']) {
        Vue.set(item, 'style', {})
      }
      
      if (!item['style'][field]) {
        Vue.set(item.style, field, {})
      }

      if (!item['style'][field][key]) {
        Vue.set(item['style'][field], key, null)
      }

      item.style[field][key] = value
    },
    itemBannerValueChanged(state, payload) {
      const { flatPageId, itemId, key, value } = payload
      const { form } = state

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const item = flatPage.items.find((i) => i.id === itemId)

      if (!item.value[key]) {
        Vue.set(item.value, key, null)
      }

      item.value[key] = value
    },
    flatPagePropChanged(state, payload) {
      const { flatPageId, key, value } = payload
      const { form } = state

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      if (!flatPage[key]) {
        Vue.set(flatPage, key, null)
      }
      flatPage[key] = value
    },
    mapMarkerRemoved(state, payload) {
      const { flatPageId, itemId, markerId } = payload
      const { form } = state

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const item = flatPage.items.find((i) => i.id === itemId)
      const markerIdx = item.value.markers.findIndex((i) => i.id === markerId)

      item.value.markers.splice(markerIdx, 1)
    },
    mapMarkerChanged(state, payload) {
      const { flatPageId, itemId, markerId, key, value } = payload
      const { form } = state

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const item = flatPage.items.find((i) => i.id === itemId)
      const marker = item.value.markers.find((i) => i.id === markerId)

      if (!marker[key]) {
        Vue.set(marker, key, null)
      }

      marker[key] = value
    },
    addMapMarker(state, payload) {
      const { flatPageId, itemId } = payload
      const { form } = state

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const item = flatPage.items.find((i) => i.id === itemId)

      if (!item.value['markers']) {
        Vue.set(item.value, 'markers', [])
      }

      const arrIds = item.value.markers.map((e) => e.id)
      const maxId = Math.max(0, ...arrIds)

      item.value.markers.push({
        id: maxId + 1,
        latitude: null,
        longitude: null,
        description: '',
        sceneName: '',
      })
    },
    itemYoutubeValueChanged(state, payload) {
      const { flatPageId, itemId, key, value } = payload
      const { form } = state
      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const item = flatPage.items.find((i) => i.id === itemId)

      if (!item.value[key]) {
        Vue.set(item.value, key, {})
      }
      
      Vue.set(item.value, key, value)
    },
    itemTextStyleChanged(state, payload) {
      const { flatPageId, itemId, key, value } = payload
      const { form } = state
      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const item = flatPage.items.find((i) => i.id === itemId)

      if (!item['style']) {
        Vue.set(item, 'style', {})
      }
      
      Vue.set(item.style, key, value)
    },
    updateFanzone(state, payload) {
      const { fanzone } = payload

      state.fanzones = state.fanzones.map(
        (f) => f.id === fanzone.id ? fanzone : f
      )

      state.fanzonesByTypeId[fanzone.fanzine_type] = state.fanzonesByTypeId[fanzone.fanzine_type].map(
        (f) => f.id === fanzone.id ? fanzone : f
      )
    },
    setNestedProp(state, payload) {
      const { keys, value } = payload
      const { form } = state
      _.set(form, `doc.${keys}`, value)
    },
    removeFlatPage(state, payload) {
      const { form } = state
      const { flatPageId } = payload
      const flatPageIdx = form.doc.flatPages.findIndex((f) => f.id === flatPageId)

      form.doc.flatPages.splice(flatPageIdx, 1)
    },
    itemImageValueChanged(state, payload) {
      const { form } = state
      const { flatPageId, itemId, value } = payload

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const item = flatPage.items.find((i) => i.id === itemId)

      Vue.set(item.value, 'base64', value)
    },
    moveUpFlatPage(state, payload) {
      const { form } = state
      const { flatPageId } = payload
      const { flatPages } = form.doc
      const flatPageIdx = flatPages.findIndex((f) => f.id === flatPageId)
      
      if (flatPageIdx > 0) {
        [flatPages[flatPageIdx - 1], flatPages[flatPageIdx]] = [flatPages[flatPageIdx], flatPages[flatPageIdx - 1]]
        Vue.set(form.doc, 'flatPages', [...flatPages])
      }
    },
    moveDownFlatPage(state, payload) {
      const { form } = state
      const { flatPageId } = payload
      const { flatPages } = form.doc
      const flatPageIdx = flatPages.findIndex((f) => f.id === flatPageId)
      
      if (flatPageIdx < flatPages.length - 1) {
        [flatPages[flatPageIdx], flatPages[flatPageIdx + 1]] = [flatPages[flatPageIdx + 1], flatPages[flatPageIdx]]
        Vue.set(form.doc, 'flatPages', [...flatPages])
      }
    },
    moveUpFlatPageItem(state, payload) {
      const { form } = state
      const { flatPageId, itemId } = payload

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const { items } = flatPage
      const itemIdx = items.findIndex((i) => i.id === itemId)

      if (itemIdx > 0) {
        [items[itemIdx - 1], items[itemIdx]] = [items[itemIdx], items[itemIdx - 1]]
        Vue.set(flatPage, 'items', [...items])
      }
    },    
    moveDownFlatPageItem(state, payload) {
      const { form } = state
      const { flatPageId, itemId } = payload

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const { items } = flatPage
      const itemIdx = items.findIndex((i) => i.id === itemId)

      if (itemIdx < items.length - 1) {
        [items[itemIdx], items[itemIdx + 1]] = [items[itemIdx + 1], items[itemIdx]]
        Vue.set(flatPage, 'items', [...items])
      }
    },
    removeFlatPageItem(state, payload) {
      const { form } = state
      const { flatPageId, itemId } = payload
 
      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const idxToRemove = flatPage.items.findIndex((i) => i.id === itemId)

      flatPage.items.splice(idxToRemove, 1)
    },
    itemTextValueChanged(state, payload) {
      const { form } = state
      const { flatPageId, itemId, value, locale } = payload

      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      const item = flatPage.items.find((i) => i.id === itemId)

      item.value[locale] = value
    },
    addFlatPageItem(state, payload){
      const { form } = state
      const { flatPageId, itemType } = payload
      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      if (!flatPage['items']) {
        Vue.set(flatPage, 'items', [])
      }

      const arrIds = flatPage.items.map((e) => e.id)
      const maxId = Math.max(0, ...arrIds)

      flatPage.items.push({
        id: maxId + 1,
        type: itemType,
        value: {},
      })

      console.log('addFlatPageItem', JSON.stringify(flatPage))
    },
    flatPageTitleChanged(state, payload) {
      const { form } = state
      const { flatPageId, value, locale } = payload
      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      flatPage.title[locale] = value
    },
    flatPageLinkChanged(state, payload) {
      const { form } = state
      const { flatPageId, value, locale } = payload
      const flatPage = form.doc.flatPages.find((f) => f.id === flatPageId)
      flatPage.link[locale] = value
    },
    addFlatPage(state) {
      const { form } = state
      const arrIds = form['doc']['flatPages'].map((e) => e.id)
      const maxId = Math.max(0, ...arrIds)

      form['doc']['flatPages'].push({
        id: maxId + 1,
        title: {},
        items: [],
      })
    },
    removeArrayItem(state, payload) {
      const { key, idx } = payload
      const { form } = state

      if (form['doc'][key]) {
        form['doc'][key].splice(idx, 1)
      }
    },
    fillForm(state, payload) {
      const { fanzone } = payload
      const { form } = state
      fanzone.doc = fanzone.doc || {}
      let obj = {...intialFormData()}
      _.merge(obj, fanzone)
      Object.assign(form, obj)
    },
    removeMarker(state, payload) {
      const { marker } = payload;
      const { form } = state;
      Vue.set(form.doc.map, 'markers', [...form.doc.map.markers.filter((it) => it.id !== marker.id)])
    },
    removeArtistsCategory(state, payload) {
      const { category } = payload;
      const { form } = state;

      Vue.set(
        form.doc.scenesData,
        'artistsCategories',
        [...form.doc.scenesData.artistsCategories.filter((it) => it.id !== category.id)]
      )
    },
    removeMarkerCategory(state, payload) {
      const { category } = payload;
      const { form } = state;

      Vue.set(form.doc.map, 'markers', [...form.doc.map.markers.filter((it) => it.categoryId !== category.id)])
      Vue.set(form.doc.map, 'markersCategories', [...form.doc.map.markersCategories.filter((it) => it.id !== category.id)])
    },
    editMarker(state, payload) {
      const { form } = state;
      const { marker, field, value, locale } = payload;

      if (locale) {
        marker[field][locale] = value
      } else {
        marker[field] = value
      }
    },
    editMarkerCategory(state, payload) {
      const { form } = state;
      const { category, field, value, locale } = payload;

      if (locale) {
        category[field][locale] = value
      } else {
        category[field] = value
      }
    },
    addMarker(state, payload) {
      const { form } = state;
      const { name, lat, lon, categoryId } = payload

      if (!form['doc']['map']) {
        Vue.set(form.doc, 'map', {})
      }
      if (!form['doc']['map']['markers']) {
        Vue.set(form.doc.map, 'markers', [])
      }

      const arrIds = form['doc']['map']['markers'].map((e) => e.id)
      const maxId = Math.max(0, ...arrIds)

      form['doc']['map']['markers'].push({
        id: maxId + 1,
        name: {
          pl: name.pl,
          en: name.en,
        },
        lat: lat,
        lon: lon,
        categoryId: categoryId,
      })
    },
    addArtistsCategory(state, payload) {
      const { form } = state
      const { name } = payload

      if (!form['doc']['scenesData']) {
        Vue.set(form.doc, 'scenesData', {})
      }

      if (!form['doc']['scenesData']['artistsCategories']) {
        Vue.set(form['doc']['scenesData'], 'artistsCategories', [])
      }
      
      const arrIds = form['doc']['scenesData']['artistsCategories'].map((e) => e.id)
      const maxId = Math.max(0, ...arrIds)

      form['doc']['scenesData']['artistsCategories'].push({
        id: maxId + 1,
        name: {
          pl: name.pl,
          en: name.en,
        }
      })
    },
    addMarkersCategory(state, payload) {
      const { form } = state
      const { name } = payload

      console.log('addMarkersCategory', name)

      if (!form['doc']['map']) {
        Vue.set(form.doc, 'map', {})
      }
      if (!form['doc']['map']['markersCategories']) {
        Vue.set(form.doc.map, 'markersCategories', [])
      }

      const arrIds = form['doc']['map']['markersCategories'].map((e) => e.id)
      const maxId = Math.max(0, ...arrIds)

      form['doc']['map']['markersCategories'].push({
        id: maxId + 1,
        name: {
          pl: name.pl,
          en: name.en,
        }
      })
    },
    addEvent(state, payload) {
      const { date, scene } = payload
      const { form } = state

      if (!form['doc']['events']) {
        Vue.set(form.doc, 'events', [])
      }

      const arrIds = form['doc']['events'].map((e) => e.id)
      const maxId = Math.max(0, ...arrIds)
      
      form['doc']['events'].push({
        id: maxId + 1,
        artistId: null,
        artistImage: null,
        artistName: "",
        eventName: "",
        timeStart: "00:00",
        timeEnd: "00:00",
        date: date,
        sceneName: scene
      })
    },
    setSimpleProp(state, payload) {
      const { key, value } = payload
      const { form } = state

      if (!form['doc'][key]) {
        Vue.set(form.doc, key, null)
      }

      form['doc'][key] = value
    },
    setSimpleArrayItem(state, payload) {
      const { key, idx, value } = payload
      const { form } = state
      
      if (!form['doc'][key]) {
        Vue.set(form.doc, key, [])
      }
      
      form['doc'][key][idx] = value
    },
    setSimpleArrayOfObjectItem(state, payload) {
      const { key, idx, objKey, value } = payload
      const { form } = state

      if (!form['doc'][key]) form['doc'][key] = []
      if (!form['doc'][key][idx]) form['doc'][key][idx] = {}
      form['doc'][key][idx][objKey] = value
    },
    setSimplePropWithLocale(state, payload) {
      const { key, value, locale } = payload
      const { form } = state

      if (!form['doc'][key]) form['doc'][key] = {}
      if (!form['doc'][key][locale]) form['doc'][key][locale] = null
      form['doc'][key][locale] = value
    },
    //set_artists(state, payload) {
    //  const { artists } = payload
    //  state.artists = Object.freeze(artists.filter(a => a.artist_status === 1))
    //},
    eventPropChanged(state, payload) {
      const { event, key, value } = payload
      event[key] = value
    },
    set_places(state, payload) {
      const { places } = payload
      state.places = Object.freeze(places)
    },
    set_fanzones(state, payload) {
      const { fanzones } = payload
      state.fanzones = Object.freeze(fanzones)
      state.fanzonesByTypeId = state.fanzones.reduce(
        (map, obj) => {
          if (!map[obj.fanzine_type]) {
            map[obj.fanzine_type] = []
          }
          map[obj.fanzine_type].push(obj)
          return map
        }, {}
      )
    },
    set_loading(state, payload) {
      const { loading } = payload
      state.loading = loading
    },
  },
  actions: {
    eventPropChanged(context, payload) {
      context.commit('eventPropChanged', payload)
    },
    removeArrayItem(context, payload) {
      context.commit('removeArrayItem', payload)
    },
    fillForm(context, payload) {
      context.commit('fillForm', payload)
    },
    addMarkersCategory(context, payload) {
      context.commit('addMarkersCategory', payload)
    },
    addArtistsCategory(context, payload) {
      context.commit('addArtistsCategory', payload)
    },
    addMarker(context, payload) {
      context.commit('addMarker', payload)
    },
    addEvent(context, payload) {
      context.commit('addEvent', payload)
    },
    setSimpleProp(context, payload) {
      context.commit('setSimpleProp', payload)
    },
    setSimpleArrayItem(context, payload) {
      context.commit('setSimpleArrayItem', payload)
    },
    setSimpleArrayOfObjectItem(context, payload) {
      context.commit('setSimpleArrayOfObjectItem', payload)
    },
    setNestedProp(context, payload) {
      context.commit('setNestedProp', payload)
    },    
    setSimplePropWithLocale(context, payload) {
      context.commit('setSimplePropWithLocale', payload)
    },
    setFanzones(context, payload) {
      context.commit('set_fanzones', payload)
    },
    setPlaces(context, payload) {
      context.commit('set_places', payload)
    },
    //setArtists(context, payload) {
    //  context.commit('set_artists', payload)
    //},
    setLoading(context, payload) {
      context.commit('set_loading', payload)
    },
    addFlatPage(context) {
      context.commit('addFlatPage') 
    },
    flatPageTitleChanged(context, payload) {
      context.commit('flatPageTitleChanged', payload) 
    },
    addFlatPageItem(context, payload) {
      context.commit('addFlatPageItem', payload) 
    },
    itemTextValueChanged(context, payload) {
      context.commit('itemTextValueChanged', payload) 
    },
    removeFlatPageItem(context, payload) {
      context.commit('removeFlatPageItem', payload) 
    },
    moveUpFlatPageItem(context, payload) {
      context.commit('moveUpFlatPageItem', payload) 
    },
    moveDownFlatPageItem(context, payload) {
      context.commit('moveDownFlatPageItem', payload) 
    },
    itemImageValueChanged(context, payload) {
      context.commit('itemImageValueChanged', payload) 
    },
    itemImageLinkChanged(context, payload) {
      context.commit('itemImageLinkChanged', payload) 
    },
    removeFlatPage(context, payload) {
      context.commit('removeFlatPage', payload) 
    },
    updateFanzone(context, payload) {
      context.commit('updateFanzone', payload) 
    },
    itemTextStyleChanged(context, payload) {
      context.commit('itemTextStyleChanged', payload) 
    },
    itemYoutubeValueChanged(context, payload) {
      context.commit('itemYoutubeValueChanged', payload) 
    },
    addMapMarker(context, payload) {
      context.commit('addMapMarker', payload) 
    },
    mapMarkerChanged(context, payload) {
      context.commit('mapMarkerChanged', payload) 
    },
    mapMarkerRemoved(context, payload) {
      context.commit('mapMarkerRemoved', payload) 
    },
    flatPagePropChanged(context, payload) {
      context.commit('flatPagePropChanged', payload) 
    },
    itemBannerValueChanged(context, payload) {
      context.commit('itemBannerValueChanged', payload) 
    },
    itemBannerStyleChanged(context, payload) {
      context.commit('itemBannerStyleChanged', payload) 
    },
    setData(context, payload) {
      context.commit('setData', payload) 
    },
    fileUploaded(context, payload) {
      context.commit('fileUploaded', payload) 
    },
    addImageToList(context, payload) {
      context.commit('addImageToList', payload) 
    },
    addFaqElementToList(context, payload) {
      context.commit('addFaqElementToList', payload) 
    },
    removeImageFromList(context, payload) {
      context.commit('removeImageFromList', payload) 
    },
    changeImageInList(context, payload) {
      context.commit('changeImageInList', payload) 
    },
    moveImageLeftInImageList(context, payload) {
      context.commit('moveImageLeftInImageList', payload) 
    },
    moveImageRightInImageList(context, payload) {
      context.commit('moveImageRightInImageList', payload) 
    },
    imageListImagePropChanged(context, payload) {
      context.commit('imageListImagePropChanged', payload) 
    },
    imageListValueChanged(context, payload) {
      context.commit('imageListValueChanged', payload) 
    },
    addDate(context) {
      context.commit('addDate') 
    },
    removeDate(context, payload) {
      context.commit('removeDate', payload) 
    },
    moveUpFlatPage(context, payload) {
      context.commit('moveUpFlatPage', payload) 
    },
    moveDownFlatPage(context, payload) {
      context.commit('moveDownFlatPage', payload) 
    },
    removeMarker(context, payload) {
      context.commit('removeMarker', payload) 
    },
    removeArtistsCategory(context, payload) {
      context.commit('removeArtistsCategory', payload) 
    },
    removeMarkerCategory(context, payload) {
      context.commit('removeMarkerCategory', payload) 
    },
    editMarker(context, payload) {
      context.commit('editMarker', payload) 
    },
    editMarkerCategory(context, payload) {
      context.commit('editMarkerCategory', payload) 
    },
    addScene(context, payload) {
      context.commit('addScene', payload) 
    },
    addDay(context, payload) {
      context.commit('addDay', payload) 
    },
    addSceneDate(context, payload) {
      context.commit('addSceneDate', payload) 
    },
    addEventToScene(context, payload) {
      context.commit('addEventToScene', payload) 
    },
    removeItemFromArray(context, payload) {
      context.commit('removeItemFromArray', payload) 
    },
    moveUpScene(context, payload) {
      context.commit('moveUpScene', payload) 
    },
    moveDownScene(context, payload) {
      context.commit('moveDownScene', payload) 
    },    
  }
}